import { HttpErrorResponse } from "@angular/common/http";

export type ErrorClassification = 'NetworkConnectionIssue' | 'ItemNotFound' | 'UnsupportedVersion' | 'Terminal'

const terminalMessage =
  'Uh-oh! An unexpected error occurred. If the issue persists, please contact support.';

function brokerMessage(body: unknown): string | null {
  if (!body || typeof body !== 'object' || !('brokerMessage' in body)) {
    return null;
  }

  const message = (body as { brokerMessage: unknown }).brokerMessage;
  if (typeof message !== 'string') {
    return null;
  }

  const text = message.trim();
  return text.length > 0 ? text : null;
}

/** Terminal dialog text. A 406 is shown only when Opportunity marks it as brokerMessage. */
export function terminalFailureMessage(
  error: unknown,
  production: boolean
): string {
  if (error instanceof HttpErrorResponse && error.status === 406) {
    const message = brokerMessage(error.error);
    if (message) {
      return `${terminalMessage}\n\n${message}`;
    }
  }

  if (production) {
    return terminalMessage;
  }

  const detail =
    error && typeof error === 'object' && 'message' in error
      ? (error as { message: unknown }).message
      : null;
  return typeof detail === 'string' && detail.length > 0
    ? `${terminalMessage}\n\n${detail}`
    : terminalMessage;
}

export function classifyError(error: any): ErrorClassification {
  if (error instanceof HttpErrorResponse)
  {
    switch (error.status)
    {
      case 0: return 'NetworkConnectionIssue';
      case 404: return 'ItemNotFound';
      case 422: return 'UnsupportedVersion';
      default: return 'Terminal';
    }
  }

  return 'Terminal';
}

function tagTerminalError(): void {
  /* TODO:
  this.hotjarService.addTag('terminal-error');
  this.heapService.addEvent('Terminal Error');
  */
}

function tagConnectivityIssues(): void {
  /* TODO:
  this.hotjarService.addTag('connectivity-issues');
  this.heapService.addEvent('Connectivity Issues');
  */
}

export function reportError(error: any): void {
  switch (classifyError(error))
  {
    case 'NetworkConnectionIssue':
      tagConnectivityIssues();
      break;
    case 'Terminal':
      console.error('Terminal error:', error);
      tagTerminalError();
      break;
  }
}